// src/enums/RoleScopeEnum.js
const RoleScopeEnum = Object.freeze({
    ORG_LEVEL: 'Org_Level',
    PROJECT_LEVEL: 'Project_Level',
    SUPER_ADMIN: 'Super_Admin',
    // Add other role scopes as needed
  });
  
  module.exports = RoleScopeEnum;